// importing essentials
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

// screens
import HomeScreen from './components/screens/home/home';
import LoginScreen from './components/screens/login/index';
import ForgotPasswordScreen from './components/screens/forgotPassword/index'
import ResetPasswordScreen from './components/screens/resetPassword/index'
import Content from './components/screens/general/Content';
import NotFound from './components/screens/general/NotFound';


const App = () => {
  // state variables declared
  const [mainRoutes, setMainRoutes] = useState([]);
  const [publicData, setPublicData] = useState({});
  const [laoding, setLoading] = useState(true);

  useEffect(() => {
    //fecth data from public api
    const fetchingRoutes = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKLINK}/api/public`, { withCredentials: true }
        );
        setMainRoutes(data.filteredMainRoutes);
        setPublicData(data)
        setLoading(false);
      }
      catch (err) {
        console.log(err)
      }
    };

    fetchingRoutes()

  }, [])

  return (
    <Router>
      <Switch>
        {/* auth routes rendering */}
        <Route exact path="/" component={HomeScreen} />
        <Route exact path="/login" component={LoginScreen} />
        <Route exact path="/forgot-password" component={ForgotPasswordScreen} />
        <Route exact path="/resetpassword/:resetToken" component={ResetPasswordScreen} />

        {/* main routes rendering */}
        {mainRoutes.map(item => (
          <Route path={item.slug} exact key={item.slug}>
            <Content
              display={item.displayName}
              route={item.slug}
              publicData={publicData}
              publicLoading={laoding}
            />
          </Route>
        ))}

        <Route component={NotFound} />

      </Switch>
    </Router>
  );
}

export default App;
